import React, { useEffect, useState } from "react";
import Select from "react-select";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Label } from "reactstrap";
import { CalenderIcon } from "../../components/Icon";
import { components } from "react-select";
import { formatDate } from "../../utils/commonFunctions";
import { CurrencyExchangeDetailsType } from "../../redux/masterData/masterTypes";
import { InvoiceWarningType } from "./AddInvoice";
import { handleHsnValidation } from "../../utils/invoiceGeneration/commonFunctions";
type DoucumentPreviosValueType = {
  label: string;
  value: string;
};
interface Props {
  item: any;
  callback: any;
  subType: string;
  index: number;
  rIdx?: number;
  client_code: number;
  selectOption: any;
  editItemIndex?: number | null;
  updateUppliersAddress?: (data: any, column: string) => void;
  handleToggleAddCustomerSupplierModal?: () => void;
  limit?: number;
  setOffset?: any;
  setText?: any;
  isLoading?: boolean;
  customerSupplierListTotalData?: string | number | any;
  offset?: number | any;
  text?: string | null;
  isAddCustomerSupplierPresent?: boolean;
  setIsSkuCode?: any;
  isSkuCode?: boolean;
  calculationDetails?: any;
  setConvert?: (data: any) => void;
  clearShippingColumn?: boolean;
  isRecepits?: any;
  setIsRecepits?: any;
  setChangeType?: (data: boolean) => void;
  setNewType?: (data: any) => void | undefined;
  currentDocumentValue?: any;
  isTypeChange?: boolean;
  setIsTypeChange?: (data: boolean) => void;
  confirmChangeType?: boolean;
  setConfirmChangeType?: (data: boolean) => void;
  onCancel?: boolean;
  setNewDocumentType?: (data: string) => void;
  singleInvoiceDetails?: any | null;
  isShippingAddressVisible?: string;
  newDocumentType?: string | undefined;
  setDoucumentPreviosValue?: (data: any) => void;
  storeDocumentType?: DoucumentPreviosValueType | any;
  setStoreDocumentType?: (data: any) => void;
  doucumentPreviosValue?: [] | DoucumentPreviosValueType[] | undefined;
  mandatoryFeild?: number;
  placeOfSupply?: string;
  setPlaceOfSupply?: (data: string) => void;
  paymentIndex?: number[];
  paymentError?: any;
  setPaymentError?: any;
  paymentErrorCount?: any;
  setPaymentErrorCount?: any;
  rowIndex?: number;
  auditSeasonMessage?: string;
  primaryData?: any;
  setCurrencyText?: React.Dispatch<React.SetStateAction<string>>;
  setDepartmentOffset?: React.Dispatch<React.SetStateAction<number>>;
  setDepartmentText?: React.Dispatch<React.SetStateAction<string>>;
  currencyExchangeDetails?: CurrencyExchangeDetailsType | undefined;
  currencyExchangeSuccess?: number | null;
  currencyExchangeError?: string | null;
  dispatchResetMasterError?: () => void;
  clientCurrencyShortForm?: string | undefined;
  currencySign?: string | undefined;
  clientCurrencyName?: string | undefined;
  clientMappedHSNData?: any;
  setInvoiceWarning?: React.Dispatch<React.SetStateAction<InvoiceWarningType>>;
  invoiceWarning?: InvoiceWarningType;
  type?: string | undefined | null;
  setSelectedSkuId?: any;
  selectedSkuId?: any;
  setSelectedMappedBatchData?:any;
  selectedMappedBatchData?:any;
}
const SingleInput = ({
  item,
  callback,
  index,
  client_code,
  rIdx,
  subType,
  selectOption,
  handleToggleAddCustomerSupplierModal,
  editItemIndex,
  updateUppliersAddress,
  limit,
  setOffset,
  setText,
  isLoading,
  isAddCustomerSupplierPresent,
  setIsSkuCode,
  isSkuCode,
  calculationDetails,
  setConvert,
  clearShippingColumn,
  isRecepits,
  setIsRecepits,
  currentDocumentValue,
  isTypeChange,
  setIsTypeChange,
  confirmChangeType,
  setConfirmChangeType,
  onCancel,
  setNewDocumentType,
  singleInvoiceDetails,
  isShippingAddressVisible,
  newDocumentType,
  setDoucumentPreviosValue,
  storeDocumentType,
  setStoreDocumentType,
  doucumentPreviosValue,
  placeOfSupply,
  setPlaceOfSupply,
  paymentIndex,
  paymentError,
  setPaymentError,
  paymentErrorCount,
  setPaymentErrorCount,
  rowIndex,
  auditSeasonMessage,
  primaryData,
  setCurrencyText,
  setDepartmentText,
  setDepartmentOffset,
  currencyExchangeDetails,
  currencyExchangeSuccess,
  currencyExchangeError,
  dispatchResetMasterError,
  clientCurrencyShortForm,
  currencySign,
  clientCurrencyName,
  clientMappedHSNData,
  setInvoiceWarning,
  invoiceWarning,
  type,
  setSelectedSkuId,
  selectedSkuId,
  setSelectedMappedBatchData,
  selectedMappedBatchData
}: Props) => {
  const [jsonData, setJsonData] = useState<any>({});

  useEffect(() => {
    if (confirmChangeType) {
      doucumentPreviosValue &&
        setDoucumentPreviosValue &&
        setDoucumentPreviosValue([
          ...doucumentPreviosValue,
          { ...storeDocumentType },
        ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmChangeType, storeDocumentType]);

  useEffect(() => {
    if (onCancel) {
      if (doucumentPreviosValue && doucumentPreviosValue?.length > 0) {
        let new_result =
          doucumentPreviosValue[doucumentPreviosValue?.length - 1];

        setJsonData(new_result);
      } else {
        setJsonData({
          value: currentDocumentValue?.column_value?.value,
          label: currentDocumentValue?.column_value?.label,
        });
      }
      setNewDocumentType &&
        setNewDocumentType(currentDocumentValue?.column_value?.label);
    } else {
      setJsonData({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onCancel]);

  const validateInt = (
    e: any,
    index: number,
    subType: string,
    rIdx?: number
  ) => {
    if (e.target.validity.valid)
      handleHsnValidation(
        e.target.value,
        clientMappedHSNData,
        setInvoiceWarning
      );
    callback(e.target.value, e.target.name, index, subType, rIdx);
    return false;
  };
  const handleJSON = (
    value: any,
    options: any,
    index: number,
    subType: string,
    rIdx: any,
    item: any,
    rowIndex: any
  ) => {
    let finalObj: any = {};
    let obj =
      options &&
      options.filter((item: any) => {
        return (
          item.ledger_id == value ||
          item.id === value ||
          item.value === value ||
          item.shipping_id === value
        );
      });
    if (item && item.column_name === "currency") {
      setPlaceOfSupply?.("");
      dispatchResetMasterError?.();
      finalObj["value"] = value?.value;
      finalObj["label"] = `${value?.value} ${
        value?.clientC ? "(" + value?.currencyShortForm + ")" : ""
      }`;
      finalObj["currencyShortForm"] = value?.currencyShortForm;
      finalObj["currencySign"] = value?.currencySign;
    }
    if (item && item.column_name === "department") {
      finalObj["value"] = obj[0]?.value;
      finalObj["label"] = obj[0]?.label;
    }
    if (
      (item && item.column_name === "supplier_name") ||
      item.column_name === "customer_name"
    ) {
      finalObj["ledger_id"] = obj[0].ledger_id;
      finalObj["legal_name"] = obj[0].legal_name;
      finalObj["state"] = obj[0].state;
      finalObj["trade_name"] = obj[0].trade_name;
    }
    if (item && item.column_name === "sku_code") {
      finalObj["value"] = obj[0].value;
      finalObj["label"] = obj[0].label;
      setIsSkuCode(true);
      setSelectedSkuId && setSelectedSkuId(obj[0].value);
    }
    if (item && item.column_name === "batch_number") {
      finalObj["value"] = obj[0].value;
      finalObj["label"] = obj[0].label;
      finalObj["expiry_date"] = obj[0]?.expiry_date;
      finalObj["manufacturing_date"] = obj[0]?.manufacturing_date;
      setSelectedMappedBatchData&&  setSelectedMappedBatchData(obj[0])
    }
    if (
      (item && item.column_name === "branch") ||
      item.column_name === "bill_from"
    ) {
      finalObj["ledger_id"] = obj[0].ledger_id;
      finalObj["trade_name"] = obj[0].trade_name;
      finalObj["state"] = obj[0].state;
    }
    if (item && item.column_name === "ship_to_name") {
      finalObj["address"] = obj[0].address;
      finalObj["gst_number"] = obj[0].gst_number;
      finalObj["legal_name"] = obj[0].legal_name;
    }

    if (
      (item && item.column_name === "nature_of_income") ||
      (item && item.column_name === "nature_of_expense") ||
      (item && item.column_name === "mode_of_receipts") ||
      (item && item.column_name === "mode_of_payment")
    ) {
      finalObj["ledger_id"] = obj[0].ledger_id;
      finalObj["ledger_name"] = obj[0].ledger_name;
      finalObj["ledger_number"] = obj[0].ledger_number;
      finalObj["ledger_type"] = obj[0].ledger_type;
    }

    if (item && item.column_name === "place_of_supply") {
      setPlaceOfSupply && setPlaceOfSupply("filled");
      let state =
        options &&
        options.filter((item: any) => {
          return item.value == value;
        });

      finalObj = state[0];
    }
    if (item && item.column_name === "mapping_tax_invoice") {
      let state =
        options &&
        options.filter((item: any) => {
          return item.value == value;
        });

      finalObj = state[0]?.data
        ? state[0]?.data
        : { label: "Select...", value: null };
    }
    if (item && item.column_name === "document_type") {
      let state =
        options &&
        options.filter((item: any) => {
          return item.value == value;
        });
      if (
        singleInvoiceDetails?.invoice_category !== 2 &&
        currentDocumentValue?.column_value?.value != undefined &&
        currentDocumentValue?.column_value?.value != state[0]?.value &&
        newDocumentType != state[0]?.label &&
        jsonData?.label != state[0]?.label
      ) {
        setIsTypeChange && setIsTypeChange(true);
        setConfirmChangeType && setConfirmChangeType(false);
        //  setJsonData(state[0])
      } else {
        // setJsonData(finalObj)
      }
      finalObj = state[0];
      setStoreDocumentType && setStoreDocumentType(finalObj);
      setNewDocumentType && setNewDocumentType(finalObj?.label);
      setIsRecepits && setIsRecepits(finalObj);
      if (
        finalObj?.value !== "purchase_order" ||
        finalObj?.value !== "estimation"
      ) {
        setConvert && setConvert(true);
      } else {
        setConvert && setConvert(false);
      }
    }

    //auto fill address and gst
    if (
      finalObj &&
      Object.keys(finalObj).length !== 0 &&
      Object.getPrototypeOf(finalObj) === Object.prototype
    ) {
      if (
        item.column_name === "supplier_name" ||
        item.column_name == "bill_from" ||
        item.column_name == "customer_name" ||
        item.column_name == "ship_to_name" ||
        item.column_name == "branch"
      ) {
        let address = {
          data: obj[0],
          column: item.column_name,
        };
        callback(
          finalObj,
          item.column_name,
          index,
          subType,
          rIdx,
          address,
          true
        );
      } else if (
        finalObj &&
        Object.keys(finalObj).length !== 0 &&
        Object.getPrototypeOf(finalObj) === Object.prototype
      ) {
        if (item.column_name === "sku_code" && obj[0]) {
          //auto fill HSN/SAC Code

          let hsn_sac_code = {
            data: obj[0]?.GST_details?.HSN_SAC_details?.HSN_SAC_no,
            column: item.column_name,
            unit: obj[0]?.stock_unit_name,
            rate: obj[0]?.rate,
          };
          handleHsnValidation(
            obj[0]?.GST_details?.HSN_SAC_details?.HSN_SAC_no,
            clientMappedHSNData,
            setInvoiceWarning
          );

          callback(
            finalObj,
            item.column_name,
            index,
            subType,
            rIdx,
            hsn_sac_code,
            true
          );
        } else if (
          item.column_name === "mode_of_payment" ||
          item.column_name === "mode_of_receipts"
        ) {
          callback(finalObj, item.column_name, index, subType, rIdx, rowIndex);
        } else {
          callback(finalObj, item.column_name, index, subType, rIdx, "", true);
        }
      }
    }
  };

  const checkBottom = () => {
    setOffset((prv: any) => prv + limit);
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          {/* <CircularAvatar name={data?.label.split("%")[0]} image={data?.image && data?.image} /> */}
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            {data?.value === null ? null : <br></br>}
            {data?.value === null ? null : (
              <span style={{ color: "#6e7491", fontSize: "14px" }}>
                {data?.label?.split("%")[1] ? data?.label?.split("%")[1] : ""}
              </span>
            )}
            {data?.value === null ? null : <br></br>}
            {data?.value === null ? null : (
              <span style={{ color: "#6e7491", fontSize: "14px" }}>
                {data?.label?.split("%")[2] ? data?.label?.split("%")[2] : ""}
              </span>
            )}
          </div>
        </div>
      </components.Option>
    );
  };
  const customerSupplierOption = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            {data?.label?.split("%")[1] ? (
              <span style={{ color: "#6e7491", fontSize: "14px" }}>
                {data?.label?.split("%")[1] ? data?.label?.split("%")[1] : ""}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      </components.Option>
    );
  };

  const renderGrid = () => {
    switch (item?.data_type) {
      case "date":
        return (
          <div className="form-group">
            <label style={{ whiteSpace: "nowrap" }}>
              {item?.name}
              {item["column_name"] == "voucher_invoice_date" ||
              ((item?.column_name === "dop_in_bank_cash" ||
                item?.column_name === "dor_in_bank_cash") &&
                (rIdx === paymentIndex?.find((el) => el === rIdx) ||
                  ((item["column_name"] === "dop_in_bank_cash" ||
                    item?.column_name === "dor_in_bank_cash") &&
                    rowIndex != undefined &&
                    rowIndex ===
                      paymentIndex?.find((el) => el === rowIndex)))) ? (
                <span className="color-red">*</span>
              ) : (
                ""
              )}
            </label>
            <div
              className="date-picker-wraper mr-0"
              // Future Use
              // style={{
              //   border:
              //     item?.column_name == "voucher_invoice_date" &&
              //       auditSeasonMessage
              //       ? "1px solid #F3A119"
              //       : "",
              //   borderRadius: "4px",
              // }}
            >
              <DatePicker
                dateFormat="dd-MM-yyyy"
                selected={
                  item?.column_value
                    ? new Date(
                        moment(
                          `${item?.column_value}T00:00:00`,
                          "YYYY-MM-DD"
                        ).format("YYYY-MM-DD[T]HH:mm:ss")
                      )
                    : null
                }
                onChange={(date: any) =>
                  callback(
                    moment(date).format("YYYY-MM-DD"),
                    item?.column_name,
                    index,
                    subType,
                    rIdx,
                    rowIndex
                  )
                }
                fixedHeight
                showMonthDropdown
                showYearDropdown
                className="form-control"
                disabled={item?.isDisabled}
              />
              <span
                className="calender-icon"
                style={{ right: "28px", top: "30px", position: "absolute" }}
              >
                <CalenderIcon />
              </span>
            </div>
            {(item?.column_name == "dop_in_bank_cash" ||
              item?.column_name == "dor_in_bank_cash") &&
            (rIdx == 0 || rIdx != undefined) &&
            paymentErrorCount[rIdx]?.includes(index) ? (
              <small className="text-danger" style={{ position: "absolute" }}>
                {"Mandatory Field is Missing"}
              </small>
            ) : (
              ""
            )}
            {(item?.column_name == "dop_in_bank_cash" ||
              item?.column_name == "dor_in_bank_cash") &&
            (rowIndex == 0 || rowIndex != undefined) &&
            paymentErrorCount[rowIndex]?.includes(index) ? (
              <small className="text-danger" style={{ position: "absolute" }}>
                {"Mandatory Field is Missing"}
              </small>
            ) : (
              ""
            )}
            {/* Future Use */}
            {/* {item?.column_name == "voucher_invoice_date" ? (
              <small style={{ position: "absolute", color: "#DD9215" }}>
                {auditSeasonMessage ? auditSeasonMessage : ""}
              </small>
            ) : (
              ""
            )} */}
          </div>
        );
      case "int":
        return item?.column_name != "allocation_id" &&
          item?.column_name != "credit_note_id" ? (
          <div className="form-group">
            <Label>{item.name}</Label>
            <input
              type="text"
              pattern="[0-9]*"
              className="form-control"
              name={item.name}
              value={item.column_value || ""}
              disabled={item?.isDisabled}
              placeholder={item.placeholder || ""}
              onChange={(e) => validateInt(e, index, subType, rIdx)}
            />
            {type === "revenues"
              ? item.column_name === "hsn_sac_code" &&
                invoiceWarning?.hsnWarning && (
                  <small style={{ color: "#be7e12" }}>
                    {`NOTE: ${invoiceWarning?.hsnWarning}`}
                  </small>
                )
              : ""}
          </div>
        ) : (
          <div className="form-group"></div>
        );
      case "double":
        return (
          <div className="form-group">
            <label>{item.name}</label>
            <input
              type="number"
              step="any"
              className="form-control"
              name={item.name}
              value={item.column_value || ""}
              disabled={item?.isDisabled}
              placeholder={item.placeholder || ""}
              onChange={(e) =>
                callback(e.target.value, item.column_name, index, subType, rIdx)
              }
              onWheel={(event) => event.currentTarget.blur()}
            />
          </div>
        );
      case "float":
        return (
          <div className="form-group">
            <label style={{ whiteSpace: "nowrap" }}>
              {item?.name}
              {item["column_name"] == "total_value" ||
              (isSkuCode && item["column_name"] == "rate") ||
              (isSkuCode && item["column_name"] == "quantity") ||
              ((item["column_name"] === "net_payment_made" ||
                item["column_name"] === "net_amount_received") &&
                rIdx === paymentIndex?.find((el) => el === rIdx)) ||
              ((item["column_name"] === "net_payment_made" ||
                item["column_name"] === "net_amount_received") &&
                rowIndex != undefined &&
                rowIndex === paymentIndex?.find((el) => el === rowIndex)) ? (
                <span className="color-red">*</span>
              ) : (
                ""
              )}{" "}
            </label>
            <input
              type="number"
              step="any"
              className="form-control"
              name={item.name}
              value={item.column_value || ""}
              placeholder={item.placeholder || ""}
              onChange={(e) => {
                callback(
                  e.target.value,
                  item.column_name,
                  index,
                  subType,
                  rIdx,
                  rowIndex
                );
              }}
              disabled={
                (calculationDetails?.itemDetailsData?.amount &&
                  calculationDetails?.itemDetailsData?.discount &&
                  item?.column_name == "total_value") ||
                (calculationDetails?.itemDetailsData?.rate &&
                  calculationDetails?.itemDetailsData?.quantity &&
                  item?.column_name == "total_value") ||
                (calculationDetails?.itemDetailsData?.amount &&
                  calculationDetails?.itemDetailsData?.gst_percentage &&
                  item?.column_name == "total_value") ||
                (calculationDetails?.itemDetailsData?.taxable_value &&
                  item?.column_name == "total_value") ||
                item?.column_name == "igst_amount" ||
                item?.column_name == "cgst_amount" ||
                item?.column_name == "sgst_amount" ||
                item?.isDisabled ||
                (!isSkuCode && item?.column_name == "rate") ||
                (!isSkuCode && item?.column_name == "quantity") ||
                (isSkuCode && item?.column_name == "amount") ||
                (calculationDetails?.itemDetailsData?.amount &&
                  calculationDetails?.itemDetailsData?.discount &&
                  item?.column_name == "taxable_value") ||
                (isSkuCode && item?.column_name == "taxable_value") ||
                (calculationDetails?.itemDetailsData?.amount &&
                  calculationDetails?.itemDetailsData?.gst_percentage &&
                  item?.column_name == "taxable_value")
                  ? true
                  : false
              }
              onWheel={(event) => event.currentTarget.blur()}
            />
            {currencyExchangeDetails?.baseCurrency !==
              clientCurrencyShortForm &&
              currencyExchangeDetails?.rate &&
              !!item.column_value &&
              item.column_value != "" &&
              item?.column_name !== "quantity" &&
              item?.column_name !== "gst_percentage" &&
              item?.column_name !== "net_amount_received" &&
              item?.column_name !== "net_payment_made" && (
                <div>
                  <span style={{ fontSize: "12px", color: "#7C8DB0" }}>{`${
                    item.column_value
                  } ${currencyExchangeDetails?.baseCurrency} = ${
                    (
                      item.column_value *
                      (currencyExchangeDetails?.rate
                        ? +currencyExchangeDetails?.rate
                        : 1)
                    )
                      ?.toString()
                      ?.split(".")[1]?.length > 2
                      ? (
                          item.column_value *
                          (currencyExchangeDetails?.rate
                            ? +currencyExchangeDetails?.rate
                            : 1)
                        )?.toFixed(2)
                      : item.column_value *
                        (currencyExchangeDetails?.rate
                          ? +currencyExchangeDetails?.rate
                          : 1)
                  } ${clientCurrencyShortForm}`}</span>
                </div>
              )}

            {(item?.column_name == "net_payment_made" ||
              item?.column_name == "net_amount_received") &&
            (rIdx == 0 || rIdx != undefined) &&
            paymentErrorCount[rIdx]?.includes(index) ? (
              <small className="text-danger" style={{ position: "absolute" }}>
                {"Mandatory Field is Missing"}
              </small>
            ) : (
              ""
            )}

            {(item?.column_name == "net_payment_made" ||
              item?.column_name == "net_amount_received") &&
            (rowIndex == 0 || rowIndex != undefined) &&
            paymentErrorCount[rowIndex]?.includes(index) ? (
              <small className="text-danger" style={{ position: "absolute" }}>
                {"Mandatory Field is Missing"}
              </small>
            ) : (
              ""
            )}
          </div>
        );
      case "textarea":
        return (
          <div className="form-group">
            <label style={{ whiteSpace: "nowrap" }}>
              {item?.name}{" "}
              {item["column_name"] == "description_as_per_bill" ? (
                <span className="color-red">*</span>
              ) : (
                ""
              )}
            </label>
            <textarea
              className="form-control"
              name={item?.name}
              value={item.column_value != null ? item.column_value : ""}
              placeholder={item.placeholder || ""}
              onChange={(e) =>
                callback(e.target.value, item.column_name, index, subType, rIdx)
              }
            />
          </div>
        );
      case "json":
        return (
          <div className="form-group" style={{ minWidth: "210px" }}>
            <label style={{ whiteSpace: "nowrap" }}>
              {item.name}{" "}
              {item["column_name"] === "nature_of_income" ||
              item["column_name"] === "nature_of_expense" ||
              (item["column_name"] === "place_of_supply" &&
                (primaryData?.find((el: any) => el?.column_name === "currency")
                  ?.column_value?.currencyShortForm === "INR" ||
                  primaryData?.find((el: any) => el?.column_name === "currency")
                    ?.column_value == null)) ||
              item["column_name"] === "customer_name" ||
              item["column_name"] === "supplier_name" ||
              item["column_name"] === "currency" ||
              item?.isDisabled ||
              item["column_name"] === "branch" ||
              item["column_name"] === "bill_from" ||
              (item["column_name"] === "ship_to_name" &&
                isShippingAddressVisible === "1") ||
              ((item["column_name"] === "mode_of_payment" ||
                item["column_name"] === "mode_of_receipts") &&
                (rIdx === paymentIndex?.find((el) => el === rIdx) ||
                  ((item["column_name"] === "mode_of_payment" ||
                    item["column_name"] === "mode_of_receipts") &&
                    rowIndex != undefined &&
                    rowIndex ===
                      paymentIndex?.find((el) => el === rowIndex)))) ? (
                <span className="color-red">*</span>
              ) : (
                ""
              )}
            </label>
            
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select Options"}
              options={
                item?.batchOptions
                  ? item?.batchOptions
                  : selectOption[item.column_name]
                  ? item.column_name === "department" ||
                    item.column_name === "mapping_tax_invoice"
                    ? [
                        { label: "Select...", value: null },
                        ...selectOption[item.column_name],
                      ]
                    : selectOption[item.column_name]
                  : []
              }
              components={
                item.column_name === "mapping_tax_invoice"
                  ? { Option }
                  : item.column_name === "supplier_name" ||
                    item.column_name === "mode_of_payment" ||
                    item.column_name === "mode_of_receipts" ||
                    item.column_name === "customer_name"
                  ? { Option: customerSupplierOption }
                  : {}
              }
              className={`${
                item["column_name"] === "place_of_supply" &&
                placeOfSupply === "Place of Supply Required"
                  ? "error-border rounded"
                  : ""
              }`}
              isDisabled={
                item?.isDisabled ||
                (item?.column_name === "currency" &&
                  !primaryData?.find(
                    (el: any) => el?.column_name === "voucher_invoice_date"
                  )?.column_value)
              }
              onChange={(data: any) => {
                (document.activeElement as HTMLInputElement)?.blur();
                handleJSON(
                  data && item?.column_name === "currency"
                    ? {
                        value: data?.value,
                        currencyShortForm: data?.currencyShortForm,
                        currencySign: data?.currencySign,
                      }
                    : data.value
                    ? data.value
                    : "",
                  selectOption[item.column_name],
                  index,
                  subType,
                  rIdx,
                  item,
                  rowIndex
                );
              }}
              value={
                item.column_name === "ship_to_name" && clearShippingColumn
                  ? { value: "", label: "Select Options" }
                  : item["column_name"] === "document_type" && onCancel
                  ? jsonData
                  : item["column_name"] === "nature_of_income" ||
                    item["column_name"] === "nature_of_expense"
                  ? item.column_value && {
                      label: item?.column_value?.ledger_name,
                      value: item?.column_value?.ledger_id,
                    }
                  : item["column_name"] === "currency"
                  ? item.column_value
                    ? item.column_value
                    : [
                        {
                          value: clientCurrencyName
                            ? clientCurrencyName
                            : "India, Rupees",
                          label: clientCurrencyName
                            ? `${clientCurrencyName} (${clientCurrencyShortForm})`
                            : "India, Rupees (INR)",
                        },
                      ]
                  : item.value
                  ? item
                  : item.column_value && item.column_value
                  ? {
                      label:
                        item.column_value?.ledger_name ||
                        (item.column_name !== "ship_to_name" && item.column_name !=="supplier_name" &&
                          item.column_value?.trade_name) ||
                        item.column_value?.legal_name ||
                        item.column_value?.label ||
                        (item.column_name === "mapping_tax_invoice" &&
                          (item.column_value?.voucher_invoice_number &&
                          item.column_value?.voucher_invoice_date
                            ? item.column_value?.voucher_invoice_number +
                              " | " +
                              formatDate(
                                item.column_value?.voucher_invoice_date
                              )
                            : item.column_value?.voucher_invoice_date &&
                              item.column_value?.voucher_invoice_date)),
                      value:
                        (item.column_name !== "ship_to_name" &&
                          item?.column_value?.ledger_id) ||
                        (item.column_name !== "ship_to_name" &&
                          item?.column_value?.ledger_number) ||
                        item?.column_value?.shipping_id ||
                        item?.column_value?.value ||
                        (item.column_name === "mapping_tax_invoice" &&
                          item?.column_value?.id),
                    }
                  : item.column_name === "document_type"
                  ? { value: "tax_invoice", label: "Tax Invoice" }
                  : ""
              }
              defaultValue={
                item.column_name === "ship_to_name"
                  ? { value: "", label: "" }
                  : item["column_name"] === "document_type" && onCancel
                  ? jsonData
                  : item.value
                  ? item
                  : item.column_value && item.column_value
                  ? {
                      label:
                        item.column_value?.ledger_name ||
                        (item.column_name !== "ship_to_name" && item.column_name !=="supplier_name" &&
                          item.column_value?.trade_name) ||
                        item.column_value?.legal_name ||
                        item.column_value?.label,
                      value:
                        (item.column_name !== "ship_to_name" &&
                          item?.column_value?.ledger_id) ||
                        (item.column_name !== "ship_to_name" &&
                          item?.column_value?.ledger_number) ||
                        item?.column_value?.shipping_id ||
                        item?.column_value?.value,
                    }
                  : item.column_name === "document_type"
                  ? { value: "tax_invoice", label: "Tax Invoice" }
                  : ""
              }
              onMenuScrollToBottom={(e: any) => {
                if (
                  item.name === "Customer Name" ||
                  item.name === "Supplier Name" ||
                  item.name === "Currency"
                ) {
                  checkBottom();
                }
                if (item.name === "Department") {
                  setDepartmentOffset?.((prv: any) => prv + limit);
                }
              }}
              onInputChange={(e: any) => {
                if (
                  item.name === "Customer Name" ||
                  item.name === "Supplier Name"
                ) {
                  setText && setText(e);
                }
                if (item.name === "Currency") {
                  setCurrencyText?.(e);
                }
                if (item.name === "Department") {
                  setDepartmentText?.(e);
                }
                if (
                  item.name === "Customer Name" ||
                  item.name === "Supplier Name" ||
                  item.name === "Currency"
                ) {
                  setOffset && setOffset(0);
                }
              }}
              isLoading={
                item.name === "Customer Name" ||
                item.name === "Supplier Name" ||
                item.name === "Currency"
                  ? isLoading
                  : false
              }
              //    isClearable
            />
            { 
            item.column_name === "batch_number" && (item?.column_value?.expiry_date ||item?.column_value?.manufacturing_date )&&
               <div style={{ color: "#be7e12"}} >
              <div> {`MFG Date: ${item?.column_value?.manufacturing_date?formatDate(item?.column_value?.manufacturing_date):""}`}</div>
              <div> {`EXP Date: ${item?.column_value?.expiry_date?formatDate(item?.column_value?.expiry_date):""}`}</div>

             </div>
             
            }

            {currencyExchangeSuccess === 1 &&
              !currencyExchangeError?.length &&
              !currencyExchangeError?.includes("list not found") &&
              currencyExchangeDetails?.baseCurrency !==
                clientCurrencyShortForm &&
              currencyExchangeDetails?.rate &&
              item?.column_name === "currency" && (
                <div>
                  <span style={{ fontSize: "12px", color: "#7C8DB0" }}>{`1 ${
                    currencyExchangeDetails?.baseCurrency
                  } = ${
                    (currencyExchangeDetails?.rate
                      ? +currencyExchangeDetails?.rate
                      : 1
                    )
                      ?.toString()
                      ?.split(".")[1]?.length > 2
                      ? (+currencyExchangeDetails?.rate)?.toFixed(2)
                      : currencyExchangeDetails?.rate
                      ? +currencyExchangeDetails?.rate
                      : 1
                  } ${clientCurrencyShortForm}`}</span>
                </div>
              )}
            {currencyExchangeSuccess === 0 &&
              currencyExchangeError?.includes("list not found") &&
              item?.column_name === "currency" && (
                <small className="text-danger pointer">
                  Something went wrong please try again!
                </small>
              )}
            {(item?.column_name == "supplier_name" ||
              item?.column_name == "customer_name") &&
              isAddCustomerSupplierPresent && (
                <small
                  className="text-danger pointer"
                  onClick={handleToggleAddCustomerSupplierModal}
                >
                  {`+ Add Customer/Supplier (If not in list)`}
                </small>
              )}
            {item?.column_name == "place_of_supply" &&
            placeOfSupply === "Place of Supply Required" ? (
              <small className="text-danger">{placeOfSupply}</small>
            ) : (
              ""
            )}
            {(item?.column_name == "mode_of_payment" ||
              item?.column_name == "mode_of_receipts") &&
            (rIdx == 0 || rIdx != undefined) &&
            paymentErrorCount[rIdx]?.includes(index) ? (
              <small className="text-danger" style={{ position: "absolute" }}>
                {"Mandatory Field is Missing"}
              </small>
            ) : (
              ""
            )}
            {(item?.column_name == "mode_of_payment" ||
              item?.column_name == "mode_of_receipts") &&
            (rowIndex == 0 || rowIndex != undefined) &&
            paymentErrorCount[rowIndex]?.includes(index) ? (
              <small className="text-danger" style={{ position: "absolute" }}>
                {"Mandatory Field is Missing"}
              </small>
            ) : (
              ""
            )}
            {item?.column_name === "document_type" &&
            (item?.column_value?.value === "debit_note" ||
              item?.column_value?.value === "credit_note") &&
            !primaryData?.find(
              (el: any) =>
                el?.column_name === "supplier_name" ||
                el?.column_name === "customer_name"
            )?.column_value ? (
              <small style={{ position: "absolute", color: "#DD9215" }}>
                {"Select Customer/Supplier to See Mapped Invoice"}
              </small>
            ) : (
              ""
            )}
          </div>
        );

      default:
        return (
          <div className="form-group">
            <label style={{ whiteSpace: "nowrap" }}>{item?.name} </label>
            <input
              type={item?.data_type}
              className="form-control"
              name={item?.name}
              value={item.column_value != null ? item.column_value : ""}
              placeholder={item.placeholder || ""}
              onChange={(e) =>
                callback(e.target.value, item.column_name, index, subType, rIdx)
              }
              disabled={
                item?.column_name === "supplier_address" ||
                item?.column_name == "supplier_gstn" ||
                item?.column_name == "address" ||
                item?.column_name == "supplier_address1" ||
                item?.column_name == "supplier_address2" ||
                item?.column_name == "customer_address1" ||
                item?.column_name == "customer_address2" ||
                item?.column_name == "bill_from_address1" ||
                item?.column_name == "bill_from_address2" ||
                item?.column_name == "branch_address1" ||
                item?.column_name == "branch_address2" ||
                item?.isDisabled ||
                item?.column_name == "gst_number" ||
                item?.column_name == "ship_to_address" ||
                item?.column_name == "ship_to_gst" ||
                item?.column_name == "customer_address" ||
                item?.column_name == "customer_gstn"
                  ? true
                  : false
              }
            />
          </div>
        );
    }
  };
  const renderHandleSwitch = () => {
    return <>{renderGrid()}</>;
  };

  return <>{item?.column_name !== "upload" ? renderHandleSwitch() : null}</>;
};

export default SingleInput;
